import { render, staticRenderFns } from "./tag-filter.vue?vue&type=template&id=2b52b626"
import script from "./tag-filter.vue?vue&type=script&lang=js"
export * from "./tag-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports